import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "belt-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Greenboard = _resolveComponent("Greenboard")!
  const _component_RandselDialog = _resolveComponent("RandselDialog")!

  return (_openBlock(), _createBlock(_component_RandselDialog, {
    title: "組み合わせを確認",
    showEventName: "openGreenboardDialog",
    class: "greenboard-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Greenboard),
      (_ctx.configBagsizeId == _ctx.bagsizeSettings.bagsizeOptions[1].id)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "マジかるベルトはシミュレータ上で表示されません"))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}